<template>
  <div data-module="work-main-articles" class="mobile">
    <div class="component-layout">
    <div class="article-tile-container"
      v-for="(record, idx) in articles"
      :key="idx"
    >
      <category-page-tile
        v-if="record.isCategory === true"
        :record="record"
      />
      <ArticleTile
        v-else
       :record="record"
      />

    </div>
    </div>
  </div>
</template>


<script>
// Components
import ArticleTile from '@/components/article-tile/ContentRevealTile';
import CategoryPageTile from '@/components/article-tile/CategoryPageTile';

export default {

  props: ['articles'],

  components: {
    ArticleTile,
    CategoryPageTile,
  },

};
</script>


<style lang="scss" scoped>
@import '~@/styles/_typography.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_grid.scss';

[data-module="work-main-articles"] {
  background: $color--quaternary-midtone;
  width: 100%;

  // media query props
  @include ngGrid('mobile');
  grid-gap: 0;
  padding: 0;

  // use padding because of bg color
  padding-top: 0; // rem(50px);
  padding-bottom: 0; // rem(80px);

  .component-layout {
    grid-column: 1 / -1;

    .article-tile-container {
      width: 100vw;
      height: 100vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/work/WorkArticlesMobile.vue